// IntegrationsContainer.js
import React, { useState } from 'react';
import { Box } from '@mui/material';
import IntegrationsMenu from 'components/integrations/IntegrationsMenu';
import IntegrationsSearch from 'components/integrations/IntegrationsSearch';
import IntegrationsCategoriesContainer from 'components/integrations/IntegrationsCategoriesContainer';
import NeedHelpContainer from 'components/integrations/NeedHelpContainer';

const IntegrationsContainer = () => {
    const [searchTerm, setSearchTerm] = useState('');

    const handleSearchChange = (newSearchTerm) => {
        setSearchTerm(newSearchTerm);
    };

    return (
        <Box sx={{ padding: 2 }}>
            <Box sx={{ mb: 3 }}>
                <IntegrationsMenu />
                <IntegrationsSearch 
                    onSearchChange={handleSearchChange}
                    searchTerm={searchTerm}
                />
            </Box>
            
            <Box sx={{ mb: 3, height: '50vh' }}>
                <IntegrationsCategoriesContainer searchTerm={searchTerm} />
            </Box>
            
            <Box>
                <NeedHelpContainer />
            </Box>
        </Box>
    );
};

export default IntegrationsContainer;